export const tr = {
    'cpa-sign': 'CPA dikkate alınarak hesaplandı',
    'many-days-clicks-title': '{value} gün için tıklama tahmini',
    'many-days-cost-title': '{value} gün için harcama tahmini',
    'many-days-ctr-title': '{value} gün için dönüşüm tahmini',
    'one-day-clicks-title': '{value} gün için tıklama tahmini',
    'one-day-cost-title': '{value} gün için harcama tahmini',
    'one-day-ctr-title': '{value} gün için dönüşüm tahmini',
    'roi-sign': 'ROI dikkate alınarak hesaplandı',
    'some-days-clicks-title': '{value} gün için tıklama tahmini',
    'some-days-cost-title': '{value} gün için harcama tahmini',
    'some-days-ctr-title': '{value} gün için dönüşüm tahmini'
};
